module.exports = __webpack_public_path__ + "img/thumbnail-placeholder-curriculum.39030a28.png";